/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IAddressCadastreSchema } from '../address_cadastre/AddressCadastreSchema';
import type { IDocumentFileSchema } from '../document_file/DocumentFileSchema';

export interface IV1ProcessFormAnswersRequestSchema {
  /** Адрес объекта/Кадастровый номер **/
  addressCadastre?: IAddressCadastreSchema;
  /** Оставьте ваш адрес электронной почты **/
  applicantEmail?: string;
  /** Как вас зовут? **/
  applicantName?: string;
  /** Оставьте ваш номер мобильного телефона **/
  applicantPhone?: string;
  /** Выписка из ЕГРН, полученная собственником **/
  egrnExtract?: IDocumentFileSchema[];
  /** Загрузите фото правоустанавливающего документа на {object_type} **/
  entitlementDocument?: IDocumentFileSchema[];
  /** Идентификатор черновика ответов **/
  legalCheckId?: number;
  /** Какую недвижимость хотите проверить? **/
  objectType: EObjectType;
  /** Приложите другие документы **/
  otherDocuments?: IDocumentFileSchema[];
  /** Загрузите фото паспорта собственника {object_type} **/
  sellerPassport?: IDocumentFileSchema[];
  /** Код шага формы с которого пришли ответы **/
  stepCode: EStepCode;
}

export enum EObjectType {
  /** Квартира **/
  'Flat' = 'flat',
  /** Дом **/
  'House' = 'house',
  /** Участок **/
  'Land' = 'land',
  /** Комната **/
  'Room' = 'room',
}
export enum EStepCode {
  /** Проверка регистрации в Росреестре **/
  'AddressCadastre' = 'addressCadastre',
  /** Проверка регистрации участка в Росреестре **/
  'AddressCadastreHouse' = 'addressCadastreHouse',
  /** Оставьте ваш адрес электронной почты **/
  'ApplicantEmail' = 'applicantEmail',
  /** Как вас зовут? **/
  'ApplicantName' = 'applicantName',
  /** Оставьте ваш номер мобильного телефона **/
  'ApplicantPhone' = 'applicantPhone',
  /** Загрузите выписку из ЕГРН, полученную собственником **/
  'EgrnExtract' = 'egrnExtract',
  /** Загрузите фото правоустанавливающего документа на {object_type} **/
  'EntitlementDocument' = 'entitlementDocument',
  /** Какую недвижимость хотите проверить? **/
  'ObjectType' = 'objectType',
  /** Приложите другие документы **/
  'OtherDocuments' = 'otherDocuments',
  /** Осталось оплатить отчёт **/
  'PayForReport' = 'payForReport',
  /** Загрузите фото паспорта собственника {object_type} **/
  'SellerPassport' = 'sellerPassport',
}
